<template>
  <div class="action_button">
    <a
      class="btn ahover hover"
      :style="{ backgroundColor: color, color: textColor }"
    >
      <slot></slot>
      <i class="fa fa-spin fa-spinner" v-if="loading === true"></i>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    color: { type: String, required: false, default: "" },
    textColor: { type: String, required: false, default: "" },
    loading: { type: Boolean, required: false, default: false }
  }
};
</script>

<style scoped>
.ahover:hover {
  opacity: 0.8;
}
.fa-spin {
  filter: blur(0);
}
</style>
